/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Qwick Core API
 * AKA V3, AKA Gigpro, AKA sidegig-api
 * OpenAPI spec version: 0.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  NetworksListParams,
  OrganizationNetworkInvitation,
  OrganizationNetworkInvitationRequest,
  OrganizationProNetwork
} from '../model';

import { customFetch } from '../../custom-fetch';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getNetworksListUrl = (orgId: string,
    params?: NetworksListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value instanceof Date ? value.toISOString() : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/networks/${orgId}/?${stringifiedParams}` : `/api/networks/${orgId}/`
}

/**
 * An organization's private talent network of pros who have an ongoing
 * relationship with the business.
 *
 * Pros in the network get priority matching, and the organization can filter
 * by skill, availability, and performance.
 */
export const networksList = async (orgId: string,
    params?: NetworksListParams, options?: Parameters<typeof customFetch>[1]): Promise<OrganizationProNetwork[]> => {

  return customFetch<OrganizationProNetwork[]>(getNetworksListUrl(orgId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getNetworksListQueryKey = (orgId: string,
    params?: NetworksListParams,) => {
    return [
    `/api/networks/${orgId}/`, ...(params ? [params] : [])
    ] as const;
    }


export const getNetworksListQueryOptions = <TData = Awaited<ReturnType<typeof networksList>>, TError = void>(orgId: string,
    params?: NetworksListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof networksList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getNetworksListQueryKey(orgId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof networksList>>> = ({ signal }) => networksList(orgId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: orgId !== null && orgId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof networksList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type NetworksListQueryResult = NonNullable<Awaited<ReturnType<typeof networksList>>>
export type NetworksListQueryError = void


export function useNetworksList<TData = Awaited<ReturnType<typeof networksList>>, TError = void>(
 orgId: string,
    params: undefined |  NetworksListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof networksList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof networksList>>,
          TError,
          Awaited<ReturnType<typeof networksList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useNetworksList<TData = Awaited<ReturnType<typeof networksList>>, TError = void>(
 orgId: string,
    params?: NetworksListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof networksList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof networksList>>,
          TError,
          Awaited<ReturnType<typeof networksList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useNetworksList<TData = Awaited<ReturnType<typeof networksList>>, TError = void>(
 orgId: string,
    params?: NetworksListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof networksList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useNetworksList<TData = Awaited<ReturnType<typeof networksList>>, TError = void>(
 orgId: string,
    params?: NetworksListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof networksList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getNetworksListQueryOptions(orgId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getNetworksInvitationsListUrl = (orgId: string,) => {




  return `/api/networks/${orgId}/invitations/`
}

/**
 * Manages invitations for pros to join an organization's private talent network.
 */
export const networksInvitationsList = async (orgId: string, options?: Parameters<typeof customFetch>[1]): Promise<OrganizationNetworkInvitation[]> => {

  return customFetch<OrganizationNetworkInvitation[]>(getNetworksInvitationsListUrl(orgId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getNetworksInvitationsListQueryKey = (orgId: string,) => {
    return [
    `/api/networks/${orgId}/invitations/`
    ] as const;
    }


export const getNetworksInvitationsListQueryOptions = <TData = Awaited<ReturnType<typeof networksInvitationsList>>, TError = void>(orgId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof networksInvitationsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getNetworksInvitationsListQueryKey(orgId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof networksInvitationsList>>> = ({ signal }) => networksInvitationsList(orgId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: orgId !== null && orgId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof networksInvitationsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type NetworksInvitationsListQueryResult = NonNullable<Awaited<ReturnType<typeof networksInvitationsList>>>
export type NetworksInvitationsListQueryError = void


export function useNetworksInvitationsList<TData = Awaited<ReturnType<typeof networksInvitationsList>>, TError = void>(
 orgId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof networksInvitationsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof networksInvitationsList>>,
          TError,
          Awaited<ReturnType<typeof networksInvitationsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useNetworksInvitationsList<TData = Awaited<ReturnType<typeof networksInvitationsList>>, TError = void>(
 orgId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof networksInvitationsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof networksInvitationsList>>,
          TError,
          Awaited<ReturnType<typeof networksInvitationsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useNetworksInvitationsList<TData = Awaited<ReturnType<typeof networksInvitationsList>>, TError = void>(
 orgId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof networksInvitationsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useNetworksInvitationsList<TData = Awaited<ReturnType<typeof networksInvitationsList>>, TError = void>(
 orgId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof networksInvitationsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getNetworksInvitationsListQueryOptions(orgId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getNetworksInvitationsCreateUrl = (orgId: string,) => {




  return `/api/networks/${orgId}/invitations/`
}

/**
 * Manages invitations for pros to join an organization's private talent network.
 */
export const networksInvitationsCreate = async (orgId: string,
    organizationNetworkInvitationRequest: OrganizationNetworkInvitationRequest, options?: Parameters<typeof customFetch>[1]): Promise<OrganizationNetworkInvitation> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<OrganizationNetworkInvitation>(getNetworksInvitationsCreateUrl(orgId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(organizationNetworkInvitationRequest)
  }
);}





export const getNetworksInvitationsCreateMutationKey = () => ['networksInvitationsCreate'] as const;

export const getNetworksInvitationsCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof networksInvitationsCreate>>, TError,NetworksInvitationsCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof networksInvitationsCreate>>, TError,NetworksInvitationsCreateMutationVariables, TContext> => {

const mutationKey = getNetworksInvitationsCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof networksInvitationsCreate>>, NetworksInvitationsCreateMutationVariables> = (props) => {
          const {orgId,data} = props ?? {};

          return  networksInvitationsCreate(orgId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type NetworksInvitationsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof networksInvitationsCreate>>>
    export type NetworksInvitationsCreateMutationBody = OrganizationNetworkInvitationRequest
    export type NetworksInvitationsCreateMutationError = void
    export type NetworksInvitationsCreateMutationVariables = {orgId: string;data: OrganizationNetworkInvitationRequest}

    export const useNetworksInvitationsCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof networksInvitationsCreate>>, TError,NetworksInvitationsCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof networksInvitationsCreate>>,
        TError,
        NetworksInvitationsCreateMutationVariables,
        TContext
      > => {
      return useMutation(getNetworksInvitationsCreateMutationOptions(options), queryClient);
    }
    export const getNetworksInvitationsDestroyUrl = (orgId: string,
    id: string,) => {




  return `/api/networks/${orgId}/invitations/${id}/`
}

/**
 * Manages invitations for pros to join an organization's private talent network.
 */
export const networksInvitationsDestroy = async (orgId: string,
    id: string, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getNetworksInvitationsDestroyUrl(orgId,id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getNetworksInvitationsDestroyMutationKey = () => ['networksInvitationsDestroy'] as const;

export const getNetworksInvitationsDestroyMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof networksInvitationsDestroy>>, TError,NetworksInvitationsDestroyMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof networksInvitationsDestroy>>, TError,NetworksInvitationsDestroyMutationVariables, TContext> => {

const mutationKey = getNetworksInvitationsDestroyMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof networksInvitationsDestroy>>, NetworksInvitationsDestroyMutationVariables> = (props) => {
          const {orgId,id} = props ?? {};

          return  networksInvitationsDestroy(orgId,id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type NetworksInvitationsDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof networksInvitationsDestroy>>>

    export type NetworksInvitationsDestroyMutationError = void
    export type NetworksInvitationsDestroyMutationVariables = {orgId: string;id: string}

    export const useNetworksInvitationsDestroy = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof networksInvitationsDestroy>>, TError,NetworksInvitationsDestroyMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof networksInvitationsDestroy>>,
        TError,
        NetworksInvitationsDestroyMutationVariables,
        TContext
      > => {
      return useMutation(getNetworksInvitationsDestroyMutationOptions(options), queryClient);
    }
    export const getNetworksInvitationsResendCreateUrl = (orgId: string,
    id: string,) => {




  return `/api/networks/${orgId}/invitations/${id}/resend/`
}

/**
 * Manages invitations for pros to join an organization's private talent network.
 */
export const networksInvitationsResendCreate = async (orgId: string,
    id: string, options?: Parameters<typeof customFetch>[1]): Promise<OrganizationNetworkInvitation> => {

  return customFetch<OrganizationNetworkInvitation>(getNetworksInvitationsResendCreateUrl(orgId,id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getNetworksInvitationsResendCreateMutationKey = () => ['networksInvitationsResendCreate'] as const;

export const getNetworksInvitationsResendCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof networksInvitationsResendCreate>>, TError,NetworksInvitationsResendCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof networksInvitationsResendCreate>>, TError,NetworksInvitationsResendCreateMutationVariables, TContext> => {

const mutationKey = getNetworksInvitationsResendCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof networksInvitationsResendCreate>>, NetworksInvitationsResendCreateMutationVariables> = (props) => {
          const {orgId,id} = props ?? {};

          return  networksInvitationsResendCreate(orgId,id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type NetworksInvitationsResendCreateMutationResult = NonNullable<Awaited<ReturnType<typeof networksInvitationsResendCreate>>>

    export type NetworksInvitationsResendCreateMutationError = void
    export type NetworksInvitationsResendCreateMutationVariables = {orgId: string;id: string}

    export const useNetworksInvitationsResendCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof networksInvitationsResendCreate>>, TError,NetworksInvitationsResendCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof networksInvitationsResendCreate>>,
        TError,
        NetworksInvitationsResendCreateMutationVariables,
        TContext
      > => {
      return useMutation(getNetworksInvitationsResendCreateMutationOptions(options), queryClient);
    }
